<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="下单时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单来源:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单编号:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单归属:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="装货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="卸货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单状态:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="search-table-box">
        <el-button
          type="primary"
          @click="
            handleDownload(
              searchForm.sourceType === '1'
                ? '轮询订单.xlsx'
                : searchForm.sourceType === '10'
                ? '线索订单.xlsx'
                : '电议订单.xlsx'
            )
          ">
          大客户订单批量导入
        </el-button>
        <el-button type="default" @click="handleSetting">下载订单导入模板</el-button>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:orderNo="{ row }">
          <div class="color1269FF cursor" @click="openDetail(row)">
            {{ row.orderNo }}
          </div>
        </template>
        <template v-slot:orderSource="{ row }">
          <!--          <span class="sty1">客户代下单</span>-->
          <span class="sty2">散客下单</span>
        </template>
        <template v-slot:status="{ row }">
          <!--          <span class="common-status status-cancel">已取消</span>-->
          <span class="common-status status-confirm">已完成</span>
          <!--          <span class="common-status status-pending-order">待派单</span>-->
          <!--          <span class="common-status status-in-progress">运输中</span>-->
        </template>
        <template v-slot:operation="{ row }">
          <div class="operate-btn" @click="openDetail(row)">详情</div>
        </template>
      </custom-table>
    </div>

    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import detail from "./detail.vue";
import { downloadTable, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getTree } from "@/views/commonApi";

export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    detail,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        keyword: "",
        startTime: "",
        deptId: "",
        deptIds: [],
        endTime: "",
        sourceType: "1",
      },
      deptList: [],
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          scopeStatus: true,
          align: "left",

          show: true,
        },
        {
          label: "订单来源",
          prop: "orderSource",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "订单归属",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "货物名称",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "订单金额",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "转货地",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "卸货地",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "订单状态",
          prop: "status",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "下单时间",
          prop: "createTime",
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "150px",
          scopeStatus: true,
          show: true,
        },
      ],
      tableData: [
        {
          orderNo: 22,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getTree() {
      getTree().then((res) => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },
    handleSetting() {
      this.$refs.config.init();
    },
    openDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
